export default function CTABanner() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="px-6 md:px-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            Ready to Shop Smarter?
          </h2>
          <p className="mt-4 text-lg text-foreground-600 max-w-xl mx-auto leading-relaxed">
            Join thousands of buyers using the VigorBuy Spreadsheet to find trusted products daily.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-all duration-200 whitespace-nowrap text-center"
            >
              Explore VigorBuy Sheet
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold border-2 border-foreground-900 text-foreground-900 rounded-lg hover:bg-foreground-900 hover:text-background-50 transition-all duration-200 whitespace-nowrap text-center"
            >
              Buy It Now
              <i className="ri-shopping-bag-line ml-2"></i>
            </a>
          </div>

          {/* Product strip */}
          <div className="mt-16 flex flex-wrap items-center justify-center gap-6 md:gap-10 opacity-60">
            {['Shoes', 'Clothing', 'Bags', 'Accessories', 'Electronics', 'Streetwear', 'Luxury Items'].map((item) => (
              <span
                key={item}
                className="text-sm font-medium text-foreground-400 whitespace-nowrap"
              >
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}